import { useAuth } from '../contexts/AuthContext';

/**
 * 權限相關的 Hook
 */
export const usePermissions = () => {
  const { user } = useAuth();

  const isObserver = () => user?.role === 'observer';
  const canWrite = () => user?.role !== 'observer';
  const isAdmin = () => user?.level === 0;
  const canCreateAgent = () => canWrite(); // 移除層級限制 - 支持無限層級下開

  return {
    user,
    isObserver,
    canWrite,
    isAdmin,
    canCreateAgent
  };
};